import { TOP_RATED_BREADCRUMBS } from 'site-modules/shared/constants/top-rated/top-rated';

const HOME_BREADCRUMB = { title: 'Home', href: '/' };

export function buildBreadcrumbs(configEntry, pageTitle, pathname) {
  const configLinks = configEntry.child('breadcrumb').links();

  return (configLinks.length ? configLinks : [HOME_BREADCRUMB])
    .map(({ title, href }) => ({ title, href }))
    .concat({
      title: pageTitle,
      href: pathname,
    });
}

export function getIndexPageBreadcrumb(year) {
  const breadcrumbsYearTitle = year ? ` ${year}` : '';
  const breadcrumbsYearHref = year ? `/${year}` : '';
  return {
    title: `Edmunds Top Rated Awards${breadcrumbsYearTitle}`,
    href: `/top-rated${breadcrumbsYearHref}`,
  };
}

export function buildArticlePageBreadcrumb(year, pageTitle, pathname) {
  return TOP_RATED_BREADCRUMBS.concat([
    getIndexPageBreadcrumb(year),
    {
      title: pageTitle,
      href: pathname,
    },
  ]);
}
